export const ERROR_BUDGET_DECIMAL_PLACES = 2;
export const SLO_DECIMAL_PLACES = 4;
export const SLI_DECIMAL_PLACES = 3;
